import { useCallback } from 'react';
import type { AnalyticsSearchDashboard } from '@/types/analytics/dashboard';
import { getSearchDashboard } from '@/services/analytics/dashboard.service';
import { useAnalyticsSection } from './use-analytics-section';

const EMPTY: AnalyticsSearchDashboard = {
  totalSearches: 0,
  avgCtrLabel: '—',
  noClickRateLabel: '—',
  zeroResultEvents: 0,
  searchesTrend: null,
  ctrTrend: null,
  noClickTrend: null,
  topQueries: [],
  zeroResults: [],
  clickthrough: [],
  table: [],
  hourlyVolume: [],
};

export function useAnalyticsSearch() {
  const loader = useCallback(() => getSearchDashboard(), []);
  return useAnalyticsSection(loader, EMPTY);
}
